/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Form_Supports_ReasoningInputs */



/**
* | output |
* | --- |
* | "Supports Reasoning" |
*
* @param {Private_Models_Form_Supports_ReasoningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_form_supports_reasoning = /** @type {((inputs?: Private_Models_Form_Supports_ReasoningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Form_Supports_ReasoningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unterstützt Reasoning")
	return /** @type {LocalizedString} */ ("Supports Reasoning")
});